import React from 'react';
import {Row, Col, DropdownButton, MenuItem} from 'react-bootstrap';
import push from '../static/push.svg';
import Moment from 'react-moment';
import {Link} from 'react-router-dom';
import Spinner from './Spinner';

export const CoachSelection = ({state, handlers}) =>{
  let {coaches, selected} = state;
  if(coaches){
    return(
      <div className="coach-selection">
        <Row className="coach-row">
          <Col xs={12} md={10} mdOffset={1}>
            {coaches.map((coach, i)=>(
              <div className={"coach-box "+(selected===coach.id?'selected':'')}
                key={'coach_'+i} id={coach.id} onClick={handlers.onCoachSelect}>
                <img src={coach.thumbnail} alt={'coach_'+coach.name}/>
                <div>
                  <span>{coach.name}</span>
                </div>
              </div>
            ))}
          </Col>
        </Row>
        <button className={selected?'selected':''} onClick={handlers.onCoachSubmit}>選択したコーチで始める</button>
      </div>
    );
  } else{
    return(
      <div className="coach-selection">
        <Spinner />
      </div>
    )
  }
}

function ChatTime(date, i){
  return(
    <h4 className="chat_time" key={`chat_date_${i}`}>
      <Moment format="YYYY年 MM月 DD日">{date}</Moment>
    </h4>
  )
}

function Chats(chatArray, coach, i, j){
  return(
    <div key={`chat_div_${i}_${j}`} className={chatArray.is_admin?"coach":"user"}>
      {chatArray.is_admin&&<div className="coach_img"><img src={coach.thumbnail} alt={'coach_'+coach.name}/></div>}
      <div className="chat_array">
        {chatArray.is_admin&&<div className="name">{coach.name}</div>}
        {chatArray.chats.map((chat,z)=>(
          <div className={"chat "+(chat.to?"push":'')} key={`chat_${i}_${j}_${z}`}>
            {chat.to?
              <div className="push">
                <div>{chat.contents}</div>
                <div className="push_link">
                  <Link className="btn" to={chat.to}>
                    {chat.to.includes('/dashboard')?'대시보드로 이동':'트레이닝으로 이동'}
                  </Link>
                </div>
              </div>:
              <div><span>{chat.contents}</span></div>
            }
          </div>
        ))}
      </div>
    </div>
  );
}

const push_modes = [{name:'強く', value:'strong'}, {name:'弱く', value:'weak'}, {name:'アラームオフ',value:'off'}];
const PushSetting = ({pushSetting, handler, onSelect}) =>{
  return(
    <DropdownButton id="push-setting" noCaret onSelect={onSelect}
      title={<img src={push} alt="push_img"/>}>
      <MenuItem disabled>プッシュアラーム設定</MenuItem>
      <MenuItem divider />
      {push_modes.map((mode,i)=>(
        <MenuItem key={"push_mode_"+i} className={pushSetting===mode.value?'selected':''}>
          <lable><input type="radio" value={mode.value}
            onChange={handler} checked={pushSetting===mode.value?'checked':''} />
            {mode.name}
          </lable>
        </MenuItem>
      ))}
    </DropdownButton>
  )
}

// export const CoachChat = ({state, handlers, chatLog}) =>{
export const CoachChat = ({state, handlers}) =>{
  let {coach, chat, pushSetting, chatLog} = state;
  let array = [];

  if(chatLog){
    for (let i=0; i<chatLog.length; i++){
      array.push(ChatTime(chatLog[i].date, i));
      for(let j=0; j<chatLog[i].chatArray.length; j++){
        array.push(Chats(chatLog[i].chatArray[j], coach, i, j));
      }
    }
  }

  return(
    <Row>
      <Col className="chatbox">
        <Row className="chatbox_title">
          <Col xs={12}>
            <PushSetting pushSetting={pushSetting} onSelect={handlers.onSelect}
              handler={handlers.onPushStateChange} />
            <div className="title_text">Chat with {coach.name}</div>
          </Col>
        </Row>
        <div className="chatbox_main" id="chat" ref={(el)=>{state.scrollDiv =el;}}>
          {chatLog?
            array:
            <Spinner />
          }
        </div>
        <div className="chatbox_input">
          <div className="input_area">
            <textarea value={chat} rows="4" onChange={handlers.onChatChange}
               onKeyPress={handlers.onKeyPress}/>
          </div>
          <div className="button_area">
            <button onClick={handlers.onChatSubmit}>
              転送
            </button>
          </div>
        </div>
      </Col>
    </Row>
  );
}

// <div style={{float:'left',clear:'both'}} ref ={(el)=>{state.scrollDiv =el;}}>
// </div>

export const UpgradeToPro = () =>{
  return(
    <Row className="upg_pro_box">
      <Col xs={12} md={10} mdOffset={1}>
        <div className="empty-pt">
          <span>
            本機能はプレミアム会員専用の機能です。プレミアムにアップグレードしますと、より多くの学習機能がご利用できます。
          </span>
          <a className="btn-upgrade" href="http://edge.themusio.com/intro#section_p5">
            Premiumにアップグレード
          </a>
        </div>
      </Col>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/components/Pro.Coach.Components.js